import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as saveAs from 'file-saver';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-variable-pay-uploadfile',
  templateUrl: './variable-pay-uploadfile.component.html',
  styleUrls: ['./variable-pay-uploadfile.component.scss'],
})
export class VariablePayUploadfileComponent implements OnInit {
  buttonColorName: any;
  selectIncrementInputYear: any;
  GetOverallIncrementBudgetGrid: any = []
  FormYear: any
  ToYear: any
  fileName: any = null;
  fileType: any = null;
  formData: any = new FormData();
  loggedInUserCompanyID: any;
  selectedYear: any;
  companyYears: any[] = [];
  loggedInCompanyFiscalyear: any;
  letterHeadUrl: any;
  isDisabled: boolean = false;
  isFileSizeIsInvalid: boolean = false;
  isIncrementLetterCreateContent: any = false
  showBrowseBtn: boolean = false;
  getUploadIncrementPolicyYear: any = []
  isDisabledUploadPolicyBtn: boolean = true;
  VPPolicyFileURL:any=null;

  constructor(public dialog: MatDialog, private router: Router, private config: Config,
    private httpService: HttpService, private encryptionService: EncryptionService,
    private loadingService: LoaderService, public sharedService: SharedService,) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
  }

  ionViewWillEnter() {
    this.getVPPolicyFile();
  }

  onClickVariablePaySetup(operation: any) {
    this.router.navigate(['/home/hrportal/variablepay', { operation: operation }]);
  }

  // triggerFileInput() {
  //   const fileInput: any = document.getElementById('fileInput') as HTMLInputElement;
  //   fileInput.click();
  // }

  uploadVPFile(event: any) {
    const inputEvent: any = event.target as HTMLInputElement;
    this.fileName = null;
    this.fileType = null;
    this.VPPolicyFileURL = null;
    this.isDisabledUploadPolicyBtn = true;
    this.formData = new FormData();
    const fileSizeInKB = inputEvent.files[0].size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;
    if (!inputEvent.files[0] || inputEvent.files[0].length == 0) {
      return;
    }
    if (inputEvent.files[0].name.includes('csv') && !inputEvent.files[0].name.includes('CSV') && !inputEvent.files[0].name.includes('xlsx') && !inputEvent.files[0].name.includes('XLSX')) {
      window.alert("File format is not supported");
      return;
    }
    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB");
      return;
    }
    this.fileName =  event.target.files[0].name;
    const fileName = event.target.files[0].name;
    const fileType = event.target.files[0].type;
    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    const url = this.config.uploadFileLocally + `?fileName=${fileName}&fileType=${fileType}`
    this.loadingService.simpleLoader();
    this.httpService.submitFormService(url, formData).subscribe((res: any) => {
      this.VPPolicyFileURL = res.data;
      this.isDisabledUploadPolicyBtn = false;
      this.showBrowseBtn = true;
      this.loadingService.dismissLoader();
    }, (error: any) => {
      this.loadingService.dismissLoader();
    })
  }
  saveVPPolicyFile() {
    if(this.VPPolicyFileURL != null){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "frequencyCycle": null,
        "fromYear": null,
        "isDeleted": false,
        "relatedToName": "Variable Pay Policy",
        "toYear": null,
        "vpPolicyFileNameBody": this.fileName,
        "vpPolicyUrlSubject": this.VPPolicyFileURL
      };
      this.httpService.callPostService(this.config.saveVPPolicyFile, request).subscribe((result: any) => {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: result?.message,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });
        successdialogRef.afterClosed().subscribe(result => {
          this.router.navigate(['/home/hrportal/variablepay', { operation: 'Setup' }]);
        });
      });
    }
  }
  onRemoveUploadedFile(){
    this.VPPolicyFileURL = null;
    this.isDisabledUploadPolicyBtn = true;
    this.showBrowseBtn = false;
  }

  downloadVPPolicyFile() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": null,
      "fromYear": null,
      "relatedToName": "Variable Pay Policy",
      "toYear": null
    };
    this.httpService.callPostService(this.config.getVPPolicyFile, request).subscribe((result: any) => {
      saveAs(result?.data?.vpPolicyUrlSubject, result?.data?.vpPolicyFileNameBody);
    });
  }

  getVPPolicyFile() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": null,
      "fromYear": null,
      "relatedToName": "Variable Pay Policy",
      "toYear": null
    };
    this.httpService.callPostService(this.config.getVPPolicyFile, request).subscribe((result: any) => {
      this.fileName = result.data?.vpPolicyFileNameBody;
      this.showBrowseBtn = true;
    });
  }

  onClickCancelUploadPolicy() {
    this.showBrowseBtn = false;
    this.isDisabledUploadPolicyBtn = true;
    this.router.navigate(['/home/hrportal/variablepay', { operation: 'Setup'}]);
  }

  onClickUploadPolicy() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Variable Pay policy successfully uploaded.',
        btn2: 'Done',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const payload = {
          // "companyId": this.loggedInUserCompanyID,
          // "fromYear": this.FormYear.toString(),
          // "incrementPolicyFileName": this.fileName,
          // "incrementPolicyUrl": this.letterHeadUrl,
          // "toYear": this.ToYear.toString(),

          "companyId": this.loggedInUserCompanyID,
          "emailContentBody": null,
          "emailContentSubject": null,
          "frequency": null,
          "frequencyCycle": null,
          "fromYear": 0,
          "toYear": 0,
          "variablePayLetterBody": null,
          "variablePayLetterSubject": null,
          "variablePayPolicyFileName": this.fileName,
          "variablePayPolicyUrl": this.letterHeadUrl
        };
        this.httpService.callPostService(this.config.variablePayPolicyUpload, payload).subscribe((result: any) => {
          if (result) {
            this.showBrowseBtn = false;
            this.isDisabledUploadPolicyBtn = true;
            this.router.navigate(['/home/hrportal/variablepay', { operation: 'Setup' }]);
          }
        })
      }
    });
  }

  getDownloadPolicy() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.FormYear.toString(),
      "toYear": this.ToYear.toString()
    }
    this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result: any) => {
      const downloadFile: any = result.data;
      if (downloadFile.incrementPolicyUrl) {
        var fileName: any = downloadFile.incrementPolicyUrl.split(environment.downloadURL)
        saveAs(downloadFile.incrementPolicyUrl, fileName[1]);
      } else {
        console.warn("error");
      }
    })
  }

}
